import React from 'react';
import { observer } from 'mobx-react';

import { Label, Input, Button } from '../../../common/materials';

import LogsTable from './component/LogsTable';
import CreatableSelect from 'react-select/creatable';
import LogsViewModel from './Logs.viewmodel';

function Logs() {
    const {
        DEFAULT_ACTION,
        companyOptions,
        userRole,
        userName,
        setUserName,
        company,
        onSelectCompany,
        action,
        toggleAction,
        isAllActionsSelected,
        toggleAllActions,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        startTime,
        setStartTime,
        endTime,
        setEndTime,
        resetDateTime,
        handleSearch,
        logs,
        userCompanyStore,
        userOptions,
        handleUserNameChange,
        exportExcel
    } = LogsViewModel();

    const { currentAdminCompany } = userCompanyStore;

    return (
        <React.Fragment>
            <div className="flex flex-col gap-4">
                <p className="text-2xl font-bold">Report Log</p>
                <div className="flex flex-col gap-4 bg-white p-4">
                    <div className="flex w-1/2 flex-row gap-4">
                        <Button
                            size="sm"
                            outline
                            className="border-primary-900 text-primary-900"
                            onClick={exportExcel}
                            disabled={userRole === 'User'}
                        >
                            Export
                        </Button>
                    </div>
                    <div className="mt-4 bg-white">
                        <p className="text-lg font-semibold">Log Information</p>
                    </div>
                    <div className="grid grid-cols-4 gap-4">
                        <div className="col-span-2 flex flex-col">
                            <Label>Company</Label>
                            <CreatableSelect
                                className="h-[32px]"
                                //options={companyOptions}
                                //value={company}
                                //onChange={selectedCompany => setCompany(selectedCompany)}
                                //isClearable
                                //isMulti
                                isDisabled={
                                    userRole === 'User' ||
                                    currentAdminCompany.length === 0 ||
                                    currentAdminCompany.length === 1
                                }
                                onChange={onSelectCompany}
                                options={companyOptions}
                                value={company}
                            />
                        </div>
                        <div className="col-span-2 flex flex-col">
                            <Label>Username</Label>
                            {userOptions !== null && userOptions.length > 0 ? (
                                <CreatableSelect
                                    options={userOptions}
                                    value={
                                        userOptions.find(option => option.value === userName) ??
                                        null
                                    }
                                    onChange={handleUserNameChange}
                                    isClearable
                                />
                            ) : (
                                <Input
                                    name="user-input"
                                    placeholder="Username"
                                    disabled={userRole === 'User'}
                                    value={userName}
                                    onChange={e => setUserName(e.target.value)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="grid grid-cols-4 gap-4">
                        <div className="col-span-2 flex flex-col">
                            <Label>Date From:</Label>
                            <div className="flex flex-row gap-2">
                                <Input
                                    type="date"
                                    name="start_date"
                                    value={startDate}
                                    onChange={e => setStartDate(e.target.value)}
                                    onClick={e => (e.currentTarget as any).showPicker?.()}
                                />
                                <Input
                                    type="time"
                                    name="start_time"
                                    value={startTime}
                                    onChange={e => setStartTime(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-span-2 flex flex-col">
                            <Label>Date To:</Label>
                            <div className="flex flex-row gap-2">
                                <Input
                                    type="date"
                                    name="end_date"
                                    value={endDate}
                                    onChange={e => setEndDate(e.target.value)}
                                    onClick={e => (e.currentTarget as any).showPicker?.()}
                                />
                                <Input
                                    type="time"
                                    name="end_time"
                                    value={endTime}
                                    onChange={e => setEndTime(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2">
                        <Label>Action</Label>
                        <label className="flex cursor-pointer items-center gap-2 text-sm font-medium">
                            <input
                                type="checkbox"
                                checked={isAllActionsSelected}
                                onChange={toggleAllActions}
                                className="h-4 w-4 cursor-pointer accent-primary-900"
                            />
                            Select All
                        </label>
                        <div className="grid grid-cols-3 gap-x-6 gap-y-2">
                            {DEFAULT_ACTION.map(option => (
                                <label
                                    key={option.value}
                                    className="flex cursor-pointer items-center gap-2 text-sm"
                                >
                                    <input
                                        type="checkbox"
                                        checked={action.some(a => a.value === option.value)}
                                        onChange={() => toggleAction(option)}
                                        className="h-4 w-4 cursor-pointer accent-primary-900"
                                    />
                                    {option.label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div className="mt-2 grid grid-cols-4 gap-4">
                        <div className="col-span-1 flex gap-4">
                            <Button className="col-span-1 flex-1 bg-zinc-300 text-black">
                                Reset
                            </Button>
                            <Button
                                className="col-span-1 flex-1 bg-primary-900 text-white"
                                onClick={handleSearch}
                            >
                                Search
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-4">
                    <LogsTable logs={logs} />
                </div>
            </div>
        </React.Fragment>
    );
}

export default observer(Logs);
